import { render, staticRenderFns } from "./welcomepage.vue?vue&type=template&id=d666730c&scoped=true&"
import script from "./welcomepage.vue?vue&type=script&lang=js&"
export * from "./welcomepage.vue?vue&type=script&lang=js&"
import style0 from "./welcomepage.vue?vue&type=style&index=0&id=d666730c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d666730c",
  null
  
)

export default component.exports